function digits(value) {
  return String(value || '').replace(/\D/g, '')
}

export function clasificarRegimenContributivo(row = {}, titularCuil = '') {
  const titular = digits(titularCuil)
  const cuit = digits(row?.cuit || row?.cuil || '')
  const bag = [
    row?.tipoActividad,
    row?.tipo,
    row?.tipoRaw,
    row?.regimen,
    row?.caja,
    row?.empresa,
    row?.razonSocial,
    row?.fuenteNormativa,
  ].map((v) => String(v || '').toLowerCase()).join(' ')

  if (/ips|caja provincial|cordoba|municipal|no transferida|reciprocidad/.test(bag)) {
    return 'PROVINCIAL'
  }
  if (/autonom|monotrib|sicam|sipam|24\.476|25\.865|moratoria|categoria\s*[a-z0-9]/.test(bag)) {
    return 'AUTONOMO'
  }
  if (titular && cuit && titular === cuit) return 'AUTONOMO'
  if (/\b(30|33)\d{9}\b/.test(cuit)) return 'DEPENDENCIA'
  if (/dependencia|ley 24\.241|empleador|relacion laboral/.test(bag)) return 'DEPENDENCIA'
  return 'DEPENDENCIA'
}
